query GetAiSettingsLanguage {
  aiSettings {
    language
  }
}
